import AddUpdatePo from './AddUpdatePo';
import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../lib/errorHandler';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import FilterListIcon from '@mui/icons-material/FilterList';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import NoDataFound from '../../Component/Common/NoDataFound';
import StatusButton from '../../Component/Common/StatusButton';
import { standardDateFormat } from '../../lib/standardDateFormat';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import IconBackground from '../../Component/Common/IconBackground';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import CommonPagination from '../../Component/Common/CommonPagination';
import { categoryNameOptions, currencyOptions, POTypeOptions, Title, useCommonStyles } from '../../utils';
import { Badge, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, MenuItem, Select, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import { changeStatusOfPurchaseOrder, deletePurchaseOrder, getPurchaseOrderById, getPurchaseOrders, downloadpurchaseOrderExcel } from '../../Redux/Actions/PurchaseOrder';
import { useConfirm } from 'material-ui-confirm';
import { useAppSelector } from '../../Redux/app/hooks';
import ViewPurchaseOrder from './ViewPurchaseOrder';
import CustomDrawer from '../../Component/Common/CustomDrawer';
import CommonSearchField from '../../Component/Common/CommonSearchField';
import { set } from 'date-fns';

const PurchaseOrder = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const confirmDialogue = useConfirm();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [selectedItem, setSelectedItem] = useState({});
    const [listData, setListData] = useState({});
    const [isOpenAddUpdatePO, setIsOpenAddUpdatePO] = useState(false);
    const [isViewPurchaseOrder, setIsViewPurchaseOrder] = useState(false);
    const [data, setData] = useState({ selectedCondition: [1, 2, 3], poDate: new Date(), deliveryDate: new Date(new Date().setDate(new Date().getDate() + 15)) })
    const [base64, setBase64] = useState("");
    const [purchaseOrderListData, setPurchaseOrderListData] = useState([]);
    const [tableOptions, setTableOptions] = useState({ currency: { name: "INR", symbol: "₹" } })
    const [poResponse, setPoResponse] = useState({});
    const [searchValue, setSearchValue] = useState('');
    const [sortConfig, setSortConfig] = useState(null); // null | true | false


    const [yearOptions, setYearOptions] = useState([]);
    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);

    const initialFilterState = {
        status: [],
        category: [],
        vendorType: ""
    };

    const [filterData, setFilterData] = useState(initialFilterState);
    const [isApllyFilter, setIsAppllyFilter] = useState(1);

    // =============== Handler ===============
    let PerPage = 10
    const tabelHeader = ["SR.", "PO NUMBER", "VENDOR NAME", "DATE", "DELIVERY DATE", "RATE (Total)", "received qty", "pending qty", "Quantity (Total)", "Status", "Action"]

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);

    const handleChangePage = (e, p) => {
        setPage(p);
    };

    const handleCategoryChange = (id) => {
        setFilterData((prev) => ({
            ...prev,
            category: prev.category.includes(id)
                ? prev.category.filter((item) => item !== id) // Remove if already selected
                : [...prev.category, id] // Add if not selected
        }));
    };

    const handleStatusChange = (status) => {
        setFilterData((prev) => ({
            ...prev,
            status: prev.status.includes(status)
                ? prev.status.filter((item) => item !== status) // Remove if already selected
                : [...prev.status, status] // Add if not selected
        }));
    };

    const handleVendorTypeChange = (id) => {
        setFilterData((prev) => ({
            ...prev,
            vendorType: prev.vendorType === id ? "" : id // Toggle selection
        }));
    };

    const filterDataCount = (filterData?.status?.length > 0 ? filterData?.status?.length : 0) + (filterData?.category?.length > 0 ? filterData?.category?.length : 0) + (filterData?.vendorType?.trim() ? 1 : 0)
    // ============= get Inventories API =============
    const _getPurchaseOrders = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
            "status": isApllyFilter ? (filterData?.status?.length > 0 ? filterData?.status : null) : null,
            "category": isApllyFilter ? (filterData?.category?.length > 0 ? filterData?.category : null) : null,
            "vendorType": isApllyFilter ? (filterData?.vendorType?.trim() ? +filterData?.vendorType : null) : null,
        }
        if (sortConfig == false || sortConfig == true) {
            body.isSort = sortConfig
        }
        response = await dispatch(getPurchaseOrders(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Get By Id Inventory Field API =============
    const _getPurchaseOrderById = async (id, isView) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getPurchaseOrderById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const res = response?.payload?.data?.response
                setSelectedItem(response?.payload?.data?.response)
                setBase64(response?.payload?.data?.blob)
                if (isView) {
                    setIsViewPurchaseOrder(true)
                } else {
                    setIsOpenAddUpdatePO(true)
                }
                const idByData = (id, list) => {
                    const tempdata = list?.find((ele) => ele?.id == id)
                    return tempdata
                }
                setData({
                    ...data,
                    "vendor": { name: res?.vendorName },
                    "vendorType": idByData(res?.vendorType, POTypeOptions),
                    "category": idByData(res?.category, categoryNameOptions),
                    "poNumber": res?.poNumber,
                    "poDate": res.poDate,
                    "deliveryDate": res.deliveryDate,
                    "defaultYear": { name: res?.defaultYear },
                    "runningMeter": res?.runningMeter,
                    "core": res?.core,
                    // "group": { group: res?.group },
                    // "size": { size: res?.size },
                    // "subGroup": { subGroup: res?.subGroup },
                    // "typeOfpaper": { paperType: res?.paperType },
                    // "color": { color: res?.color },
                    // "micron": { micron: res?.micron },
                    // "coatingPreferences": { value: res?.coatingPreferences, label: res?.coatingPreferences },
                    // "chemicalName": { chemicalName: res?.chemicalName },
                    // "chemicalCategory": { chemicalCategory: res?.categoryName },
                    // "chemicalCode": { chemicalCode: res?.chemicalCode },
                    // "inkName": { itemName: res?.category == 4 ? res?.itemName : "" },
                    // "pantoneNumber": { pantoneNumber: res?.pantoneNumber },
                    // "packagingName": { itemName: res?.category == 5 ? res?.itemName : "" },
                    // "otherName": { itemName: res?.category == 6 ? res?.itemName : "" },
                    "productionMonth": { name: res?.productionMonth },
                    "additionalTermsAndConditions": res?.description,
                    // "additionalPaymentCondition": res?.paymentDescription,
                    "isProductionMonth": res?.productionMonth ? true : false,
                    "isRuninngMeter": res?.runningMeter ? true : false,
                    "isCore": res?.core ? true : false,
                    "isPort": res?.port ? true : false,
                    "isAdditionalTermsAndCondition": res?.description ? true : false,
                    "port": { label: res?.port, value: res?.port },
                    "status": res?.portData,
                    "selectedCondition": res?.selectedCondition,
                    "productionYear": { name: res?.productionYear, id: res?.productionYear }
                    // "isAdditionalPaymentCondition": res?.paymentDescription ? true : false,
                })
                setPurchaseOrderListData(res?.purchaseOrder)

                const findCurrency = currencyOptions?.find((ele) => ele?.name == res?.moneyType)
                setTableOptions({
                    ...tableOptions,
                    currency: findCurrency,
                    unit: { unit: res?.unitType }
                })
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Delete Inventory Field API =============
    const _deletePurchaseOrder = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(deletePurchaseOrder(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSnackBar("success", response?.payload?.message)
                _getPurchaseOrders();
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= Delete Inventory Field API =============
    const _changeStatusOfPurchaseOrder = async (row, newValue) => {
        setFullPageLoader(true);
        let response;
        let body = {
            _id: row?._id,
            status: newValue,
        }
        response = await dispatch(changeStatusOfPurchaseOrder(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSnackBar("success", response?.payload?.message)
                const updatedList = listData?.response?.map((ele) => ele?._id === row?._id ? { ...ele, status: newValue } : { ...ele })
                setListData({
                    ...listData,
                    response: updatedList,
                })
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (searchValue) {
            _getPurchaseOrders();
        } else {
            _getPurchaseOrders();
        }
    }, [page, searchValue])
    useEffect(() => {
        setPage(1)
    },[searchValue])

    useEffect(() => {
        setPage(1)
        _getPurchaseOrders(1);
    }, [isApllyFilter, searchValue, sortConfig])


    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 5 }, (_, i) => {
            const startYear = currentYear - (i + 1);
            const endYear = startYear + 1;
            return {
                id: `${startYear}-${endYear.toString().slice(-2)}`,
                name: `${startYear}-${endYear.toString().slice(-2)}`,
            };
        });
        setYearOptions(years);
    }, []);

    const handleSort = (column) => {
        setSortConfig(prev => {
            if (prev === null) return true;
            return !prev;
        });
    };

    const handleDownloadPoExcel = async () => {
        setFullPageLoader(true);
        try {
            let body = {
                "search": searchValue,
                "status": filterData?.status?.length > 0 ? filterData?.status : null,
                "category": filterData?.category?.length > 0 ? filterData?.category : null,
                "vendorType": filterData?.vendorType?.trim() ? +filterData?.vendorType : null,
            }
            if (sortConfig == false || sortConfig == true) {
                body.isSort = sortConfig
            }
            const response = await dispatch(downloadpurchaseOrderExcel(body));
            if (response?.payload) {
                const url = window.URL.createObjectURL(new Blob([response.payload.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Purchase_Order_List.xlsx");
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
                setSnackBar("success", "Excel downloaded successfully");
            }
        } catch (error) {
            console.error("Download error:", error);
            setSnackBar("error", "Failed to download Excel");
        } finally {
            setFullPageLoader(false);
        }
    }
    return (
        <>
            {isOpenAddUpdatePO ?
                <AddUpdatePo setSearchValue={setSearchValue} poResponse={poResponse} setPoResponse={setPoResponse} setIsOpenAddUpdatePO={setIsOpenAddUpdatePO} base64={base64} setBase64={setBase64} setData={setData} data={data} tableOptions={tableOptions} setTableOptions={setTableOptions} purchaseOrderListData={purchaseOrderListData} setPurchaseOrderListData={setPurchaseOrderListData} selectedItem={selectedItem} setSelectedItem={setSelectedItem} _getPurchaseOrders={_getPurchaseOrders} />
                :
                <Grid container spacing={2} padding={"25px"}>
                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Purchase Order List (PO)</Typography>
                        <Box display={"flex"} gap={1} flexWrap={'wrap'}>
                            <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["Po Number", "Vendor Name", "Item Name"]} />
                            <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
                                <Button className={classes.cancelButton} startIcon={<FilterListIcon />} onClick={() => setIsOpenFilterDrawer(true)}>Filters </Button>
                            </Badge>
                            <button style={{ backgroundColor: "#e77843", border: "none", color: "#fff", borderRadius: "8px", padding: "8px 16px", cursor: "pointer", fontWeight: "600" }} onClick={handleDownloadPoExcel} >
                                ⬇
                            </button>
                            {getPermissionList?.editPermission?.includes('Purchase Order') &&
                                <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenAddUpdatePO(true)}>Create PO</Button>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                            <TableContainer>
                                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                    <TableHead>
                                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                            {tabelHeader?.map((ele) => (
                                                <StyledTableCell key={ele}>
                                                    {ele}

                                                    {/* Only PO NUMBER is sortable */}
                                                    {ele === "PO NUMBER" && (
                                                        <span
                                                            style={{ cursor: "pointer", marginLeft: 6 }}
                                                            onClick={() => handleSort(ele)}
                                                        >
                                                            {sortConfig === null
                                                                ? "⬍" // No sort applied yet
                                                                : sortConfig
                                                                    ? "⬆" // Ascending
                                                                    : "⬇"}
                                                        </span>
                                                    )}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>

                                    </TableHead>
                                    <TableBody>
                                        {listData?.response?.length > 0 ?
                                            listData?.response?.map((row, index) => (
                                                <React.Fragment key={index}>
                                                    <StyledTableRow>
                                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                        <StyledTableCell> {row.poNumber ? row.poNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.vendorName ? row.vendorName : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.poDate && standardDateFormat(row?.poDate)}</StyledTableCell>
                                                        <StyledTableCell> {row?.deliveryDate && standardDateFormat(row?.deliveryDate)}</StyledTableCell>
                                                        <StyledTableCell>
                                                            {Number(row?.purchaseOrder?.reduce((acc, item) => acc + (item?.ratePerUnit || 0), 0).toFixed(3))}
                                                        </StyledTableCell>
                                                        <StyledTableCell> {row?.totalSupplyQuantity} {row?.unitType}</StyledTableCell>
                                                        <StyledTableCell> {

                                                            `
                                                       ${(
                                                                Math.max(
                                                                    0,
                                                                    (row?.purchaseOrder?.reduce(
                                                                        (acc, item) => acc + (parseFloat(item?.quantity) || 0),
                                                                        0
                                                                    ) || 0) - (parseFloat(row?.totalSupplyQuantity) || 0)
                                                                )
                                                            ).toFixed(3)} ${row?.unitType ?? ""}
                                                       `
                                                        }</StyledTableCell>
                                                        <StyledTableCell> {row?.purchaseOrder?.reduce((acc, item) => acc + (item?.quantity || 0), 0)}  {row?.unitType}</StyledTableCell>
                                                        <StyledTableCell>
                                                            {/* <StatusButton text={row.status || "Close"} color={row.status == "Pending" ? "primary" : row.status == "Balance" ? "success" : "gray"} /> */}
                                                            <Box display={'flex'} justifyContent={"center"} alignItems={"center"} gap={2}>
                                                                <FormControl size="small">
                                                                    <Box
                                                                        sx={{
                                                                            position: "relative",
                                                                            display: "inline-block",
                                                                            borderRadius: "30px",
                                                                            width: "fit-content",
                                                                            padding: "3px",
                                                                            "&::before": {
                                                                                content: '""',
                                                                                position: "absolute",
                                                                                inset: 0,
                                                                                borderRadius: "30px",
                                                                                padding: "2px",
                                                                                background: row?.status === "Balance" ? "linear-gradient(to top, #10B981, #10B98100)" : row?.status === "Pending" ? "linear-gradient(to top, #FFA62B, #FFA62B00)" : "linear-gradient(to top, #EF4444, #EF444400)",
                                                                                WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                                                                                WebkitMaskComposite: "destination-out",
                                                                                maskComposite: "exclude",
                                                                            },
                                                                        }}
                                                                    >
                                                                        <Select
                                                                            value={row.status}
                                                                            onChange={(e) => _changeStatusOfPurchaseOrder(row, e.target.value)}
                                                                            sx={{
                                                                                width: "fit-content",
                                                                                minWidth: "100px",
                                                                                color: row?.status === "Balance" ? "#1ABC86" : row?.status === "Pending" ? "#FF9807" : "#EF4444",
                                                                                borderRadius: "30px",
                                                                                "&.MuiOutlinedInput-root": {
                                                                                    borderRadius: "30px",
                                                                                },
                                                                                "& .MuiOutlinedInput-input": {
                                                                                    borderRadius: "30px",
                                                                                    padding: "6px 15px",
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    backgroundColor: row?.status === "Balance" ? "#ECFDF5" : row?.status === "Pending" ? "#FFF6E9" : "#FFEDED",
                                                                                    borderRadius: "30px",
                                                                                },
                                                                                "& .MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                                                                                    borderRadius: "30px",
                                                                                },
                                                                                "& .MuiOutlinedInput-notchedOutline": {
                                                                                    border: "none",
                                                                                },
                                                                                "& .MuiSelect-icon": {
                                                                                    color: row?.status === "Balance" ? "#1ABC86" : row?.status === "Pending" ? "#FF9807" : "#EF4444",
                                                                                },
                                                                            }}
                                                                        >
                                                                            <MenuItem value="Balance">Balance</MenuItem>
                                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                                            <MenuItem value="Close">Close</MenuItem>
                                                                        </Select>
                                                                    </Box>
                                                                </FormControl>
                                                            </Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <Box display={"flex"} gap={1}>
                                                                {getPermissionList?.viewPermission?.includes('Purchase Order') &&
                                                                    <IconBackground icon={"visibility"} onClick={() => _getPurchaseOrderById(row?._id, true)} />
                                                                }
                                                                {getPermissionList?.editPermission?.includes('Purchase Order') &&
                                                                    <IconBackground icon={"edit"} disabled={row.status == "Close" || row.status == "Balance"} onClick={() => _getPurchaseOrderById(row?._id, false)} />
                                                                }
                                                                {getPermissionList?.editPermission?.includes('Purchase Order') &&
                                                                    <IconBackground icon={"delete"} disabled={row.status === 1}
                                                                        onClick={(e) => {
                                                                            confirmDialogue({
                                                                                title: `Are you sure you want to delete?`,
                                                                            }).then(() => {
                                                                                _deletePurchaseOrder(row?._id)
                                                                            }).catch((err) => { console.error(err) });
                                                                        }}
                                                                    />
                                                                }
                                                            </Box>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                </React.Fragment>
                                            ))
                                            :
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={12}>
                                                    <NoDataFound />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <CommonPagination
                                totalCount={listData?.count}
                                count={Math.ceil(listData?.count / PerPage)}
                                itemsPerPage={PerPage}
                                page={page}
                                onChange={handleChangePage}
                            />
                        </Box>
                    </Grid>
                    <CustomDrawer
                        isDrawerOpen={isViewPurchaseOrder}
                        handleClose={() => { setIsViewPurchaseOrder(false); setBase64(''); setSelectedItem({}); setData({}); setPurchaseOrderListData([]) }}
                        title="View Purchase Order"
                    >
                        <ViewPurchaseOrder base64={base64} />
                    </CustomDrawer>

                    <CustomDrawer
                        isOnlyIconClose
                        isDrawerOpen={isOpenFilterDrawer}
                        handleClose={() => { setIsOpenFilterDrawer(false); setIsAppllyFilter(isApllyFilter + 1) }}
                        title="Filter"
                    >
                        <Grid container p={2}>
                            {/* Category Section */}
                            <Grid item xs={12}>
                                <Title>Category</Title>
                            </Grid>
                            {categoryNameOptions.map((ele) => (
                                <Grid item xs={12} sm={6} md={4} key={ele.id}>
                                    <FormControl component="fieldset">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={filterData.category.includes(ele.id)}
                                                        onChange={() => handleCategoryChange(ele.id)}
                                                    />
                                                }
                                                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                label={ele.name}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                            ))}

                            {/* Status Section */}
                            <Grid item xs={12}>
                                <Title>Status</Title>
                            </Grid>
                            {["Balance", "Pending", "Close"].map((ele) => (
                                <Grid item xs={12} sm={6} md={4} key={ele}>
                                    <FormControl component="fieldset">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={filterData.status.includes(ele)}
                                                        onChange={() => handleStatusChange(ele)}
                                                    />
                                                }
                                                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                label={ele}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                            ))}

                            {/* Vendor Type Section */}
                            <Grid item xs={12}>
                                <Title>Vendor Type</Title>
                            </Grid>
                            {POTypeOptions.map((ele) => (
                                <Grid item xs={12} sm={6} md={4} key={ele.id}>
                                    <FormControl component="fieldset">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={filterData.vendorType === ele.id.toString()}
                                                        onChange={() => handleVendorTypeChange(ele.id.toString())}
                                                    />
                                                }
                                                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                label={ele.name}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                            ))}

                            {/* Buttons */}
                            <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                                <Button className={classes.cancelButton}
                                    onClick={() => {
                                        setFilterData(initialFilterState);
                                        // setIsOpenFilterDrawer(false); setIsAppllyFilter(isApllyFilter + 1)
                                    }}
                                >
                                    Reset Filter
                                </Button>
                                <Button
                                    className={classes.saveButton}
                                    onClick={() => { setIsOpenFilterDrawer(false); setIsAppllyFilter(isApllyFilter + 1) }}
                                >
                                    Apply Filter
                                </Button>
                            </Grid>
                        </Grid>
                    </CustomDrawer>
                </Grid>
            }
        </>
    )
}

export default PurchaseOrder